import { getApplication } from '@ms/yammer-libs-static-config';

type IsTeamsBrandedExperience = () => boolean;
export const isTeamsBrandedExperience: IsTeamsBrandedExperience = () =>
  getApplication() === 'YAMMER_TEAMS_BRANDED_EXPERIENCES_APP';
